<template>
  <div>
    <show-parametros ref="ShowParametros" />
  </div>
</template>

<script>
import ShowParametros from '@/views/app/administration/components/ShowParametros.vue'

export default {
  components: { ShowParametros },
}
</script>
